import React from "react";
import UserEdit from "src/components/Users/Edit/UserEdit";
// import ManageUserEditSection from "src/components/Users/Edit/ManageUserEditSection";

const Edit = () => {
  return <UserEdit />;
};

export default Edit;
